// extracted by mini-css-extract-plugin
module.exports = {"loadingblock":"_1QzFFOcmjxLIZm_plt-i-L"};